// extracted by mini-css-extract-plugin
export default {"message":"message-oracular_message__fJVGx","expert_image":"message-oracular_expert_image__UW707","container":"message-oracular_container__yNkGv"};